export default "__VITE_ASSET__Bgxko3ja__"